import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async createContactInfo(context, contactInfo) {
      if (contactInfo.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/contact-info`,
            data: {
              accountId: contactInfo.accountId,
              customerId: contactInfo.customerId,
              type: contactInfo.type,
              label: contactInfo.label,
              detail: contactInfo.detail,
              receiveNotification: contactInfo.receiveNotification
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/delete", {
            entity: "contactInfos",
            where: contactInfo.tempId
          });
          store.dispatch("entities/insert", {
            entity: "contactInfos",
            where: parseInt(response.id),
            data: response.data
          });
          store.dispatch("entities/customers/fetchCustomerDataJoins", {
            joins: "contactInfos",
            customerId: contactInfo.customerId
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async updateContactInfo(context, contactInfo) {
      if (contactInfo.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/contact-info/${contactInfo.id}`,
            data: {
              accountId: contactInfo.accountId,
              id: contactInfo.id,
              type: contactInfo.type,
              label: contactInfo.label,
              detail: contactInfo.detail,
              receiveNotification: contactInfo.receiveNotification
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/update", {
            entity: "contactInfos",
            where: parseInt(response.data.id),
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async deleteContactInfo(context, contactInfo) {
      const store = this;
      store.dispatch("entities/contactInfos/delete", contactInfo.id);

      if (contactInfo.isDirty === true) {
        try {
          await axios({
            method: "patch",
            url: API_BASE_URL + `/contact-info/${contactInfo.id}`,
            data: {
              accountId: contactInfo.accountId,
              id: contactInfo.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/contact-info?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let contactInfos = [];
    obj.forEach(function(contactInfo) {
      contactInfos.push({
        accountId: contactInfo.accountId,
        id: contactInfo.id,
        isDirty: false,
        customerId: contactInfo.customerId,
        type: contactInfo.type,
        label: contactInfo.label,
        detail: contactInfo.detail,
        receiveNotification: contactInfo.receiveNotification,
        createdAt: Date.parse(response.createdAt),
        updatedAt: Date.parse(response.updatedAt)
      });
    });
    if (contactInfos.length > 0) {
      store.dispatch("entities/insert", {
        entity: "contactInfos",
        data: contactInfos
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
